import script from "./fullscreen.vue?vue&type=script&setup=true&lang=js"
export * from "./fullscreen.vue?vue&type=script&setup=true&lang=js"

import "./fullscreen.vue?vue&type=style&index=0&id=2602725b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2602725b"]])

export default __exports__